var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirBallon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 258,
    viewBox: "0 0 171 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3821_7011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.392 233.227C67.3455 233.189 64.7305 237.81 64.7305 242.09C64.7305 243.113 65.1095 245.083 66.777 246.295C68.3688 247.469 70.7185 247.583 72.424 246.447C74.4326 245.121 74.5842 243.151 74.5842 241.939C74.5842 237.848 70.8322 233.264 69.392 233.227Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.38 233.227C99.3338 233.189 96.7188 237.81 96.7188 242.09C96.7188 243.113 97.0977 245.083 98.7653 246.295C100.357 247.469 102.707 247.583 104.412 246.447C106.421 245.121 106.572 243.151 106.572 241.939C106.572 237.848 102.82 233.264 101.38 233.227Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7476 202.62L65.7559 203.091L72.4765 231.513L74.4682 231.043L67.7476 202.62Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7871 195.667L73.7461 195.819L76.2701 229.818L78.3111 229.667L75.7871 195.667Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2121 195.643L92.6797 229.639L94.7205 229.791L97.2529 195.795L95.2121 195.643Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 202.64L96.5566 231.062L98.5483 231.533L105.269 203.11L103.277 202.64Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.316 13.9019C126.165 5.00012 113.583 2.99248 104.07 1.51516C88.3042 -1.02279 76.5555 -0.26519 59.9179 2.99248C32.1001 8.44719 17.1679 23.1067 11.2557 32.2736C9.8913 34.3949 3.22108 45.0013 0.83345 61.0624C-2.23636 81.8205 3.82747 98.4119 7.27627 107.2C15.7277 128.526 58.4019 183.717 58.4019 183.717L58.4777 184.021H111.802C111.802 184.021 149.208 133.489 161.639 109.814C165.429 102.617 183.468 67.0095 156.181 29.8114C153.642 26.3265 147.957 19.7733 139.316 13.9019Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0171 15.8717C76.0257 8.9397 78.2996 5.18959 79.3229 3.63652C80.1946 2.27284 81.1042 1.09856 81.9 0.0758057C78.1101 0.227325 74.2823 0.606124 70.2272 1.2122C68.7112 1.9698 67.1194 2.87892 65.5656 3.97744C39.1121 22.1977 44.8349 65.002 46.7677 77.8432C52.3768 115.117 71.4399 170.725 75.9878 183.983H81.3315C79.3608 166.937 75.6088 135.345 75.0403 129.777C73.8276 117.958 67.6879 63.1458 71.402 30.7585C71.6673 28.1448 72.0463 22.6522 74.0171 15.8717Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2531 55.2288C19.2531 35.4934 29.9406 18.9399 40.9692 8.78809C29.9027 13.561 22.0198 19.7354 16.7518 25.3416C14.1747 29.1675 11.7113 33.6373 9.77841 38.7132C8.79303 41.2512 6.3296 48.1832 5.49583 57.5774C4.62415 67.2747 5.95061 74.6612 6.82229 79.3962C8.79303 90.0026 12.0523 97.427 16.4107 107.162C21.5271 118.602 26.3402 127.049 28.311 130.458C40.3628 151.027 53.7412 170.384 63.178 184.021H68.6733C57.7206 163.187 37.1035 122.049 35.815 118.905C33.6926 113.753 19.2531 85.7979 19.2531 55.2288Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.904 38.6754C160.274 35.7208 158.379 32.7283 156.181 29.7736C153.642 26.3266 147.957 19.7733 139.316 13.9019C137.762 12.8413 136.208 11.8943 134.693 11.0231C144.849 21.2885 154.059 36.895 154.059 55.2289C154.059 85.7601 139.657 113.753 137.497 118.867C136.171 122.011 115.591 163.149 104.639 183.983H108.315C112.408 177.922 116.615 172.088 120.973 165.838C129.576 153.414 133.972 146.898 138.824 138.906C142.992 132.087 147.616 124.473 152.732 113.791C160.805 96.9347 163.496 86.2525 164.329 82.6918C166.262 74.5477 166.603 69.3202 166.641 65.4944C166.641 63.6761 166.641 57.9941 164.974 49.9636C164.329 46.8953 163.382 43.0695 161.904 38.6754Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.034 3.97741C107.784 3.10617 106.495 2.34857 105.282 1.70461C104.866 1.62885 104.487 1.59097 104.108 1.51521C100.09 0.871253 96.3004 0.454574 92.6621 0.227295C93.458 1.21217 94.3297 2.34857 95.1634 3.67437C96.1488 5.22744 98.4227 8.97755 100.469 15.9096C102.44 22.6522 102.819 28.1827 103.122 30.7964C106.836 63.1837 100.697 117.958 99.4839 129.814C98.9154 135.383 95.1634 166.975 93.1927 184.021H98.688C103.236 170.763 122.261 115.155 127.908 77.8811C129.765 65.0019 135.488 22.1976 109.034 3.97741Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8309 203.301H105.17C105.17 203.301 107.141 196.483 111.802 183.983H58.4785L65.8309 203.301Z",
    fill: "#3E809D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8085 226.029H75.1914C72.1595 226.029 69.6582 228.529 69.6582 231.56V252.469C69.6582 255.5 72.1595 258 75.1914 258H95.8085C98.8404 258 101.342 255.5 101.342 252.469V231.56C101.342 228.529 98.8404 226.029 95.8085 226.029Z",
    fill: "#FCEFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2578 0.833313C74.2053 0.719673 75.1149 0.606033 76.0244 0.530273C75.1149 0.606033 74.1674 0.719673 73.2578 0.833313Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2988 20.9854C21.6399 20.6824 22.0189 20.3794 22.3979 20.0385C22.0189 20.3415 21.6399 20.6445 21.2988 20.9854Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0938 11.5912C35.7001 11.2882 36.2686 10.9852 36.875 10.6821C36.3065 10.9473 35.7001 11.2503 35.0938 11.5912Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1895 1.21217C71.1748 1.06065 72.1602 0.947014 73.1456 0.833374C72.1981 0.947014 71.2127 1.09853 70.1895 1.21217Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3125 12.5383C33.881 12.2352 34.4495 11.9322 35.018 11.6292C34.4116 11.9322 33.8431 12.2352 33.3125 12.5383Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 18.8264C24.2931 18.5233 24.7099 18.2203 25.1268 17.9172C24.7099 18.1824 24.2931 18.4854 23.9141 18.8264Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7559 16.6672C27.2106 16.3641 27.6275 16.0611 28.1202 15.7581C27.6654 16.0611 27.2106 16.3641 26.7559 16.6672Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3105 15.6065C28.7653 15.3035 29.258 15.0005 29.7507 14.6595C29.2201 15.0005 28.7653 15.3035 28.3105 15.6065Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9306 8.78809C40.779 8.82597 40.6653 8.90173 40.5137 8.97749C40.6653 8.90173 40.8169 8.86385 40.9306 8.78809Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5527 8.97754C40.0221 9.20482 39.4915 9.4321 38.9609 9.69726C39.4536 9.4321 39.9842 9.20482 40.5527 8.97754Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0957 0.265167C80.0432 0.189407 80.9528 0.151527 81.9002 0.113647C80.9528 0.151527 80.0053 0.189407 79.0957 0.265167Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2148 0.492416C77.1244 0.416656 77.9961 0.340897 78.9057 0.265137C77.9961 0.340897 77.0865 0.416656 76.2148 0.492416Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0254 0.530263C76.1012 0.530263 76.1391 0.530263 76.2149 0.530263C76.1391 0.492383 76.1012 0.530263 76.0254 0.530263Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7246 18.9778C23.8004 18.9399 23.8383 18.8642 23.9141 18.8263C23.8383 18.8642 23.7625 18.9021 23.7246 18.9778Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.127 17.8793C25.2028 17.8414 25.2406 17.7657 25.3164 17.7278C25.2406 17.8035 25.1649 17.8414 25.127 17.8793Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3984 20.0385C22.4742 20.0006 22.5121 19.9248 22.5879 19.887C22.5121 19.9248 22.4363 20.0006 22.3984 20.0385Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1621 12.6519C33.2 12.6141 33.2379 12.6141 33.3137 12.5762C33.2379 12.5762 33.2 12.6141 33.1621 12.6519Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9805 11.6291C35.0184 11.5912 35.0563 11.5912 35.0942 11.5533C35.0563 11.5912 35.0184 11.6291 34.9805 11.6291Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5664 16.8186C26.6422 16.7808 26.6801 16.7429 26.7559 16.6671C26.718 16.705 26.6422 16.7808 26.5664 16.8186Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9141 10.6442C36.952 10.6442 36.952 10.6063 36.9899 10.6063C36.952 10.6442 36.9141 10.6442 36.9141 10.6442Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1211 15.758C28.1969 15.7202 28.2348 15.6823 28.3106 15.6444C28.2348 15.6823 28.159 15.7202 28.1211 15.758Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.418 13.6746C31.4559 13.6368 31.5317 13.5989 31.5696 13.5989C31.4938 13.5989 31.4559 13.6368 31.418 13.6746Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.26 32.7283C42.9016 50.6455 45.5545 69.9263 46.7294 77.8432C49.7613 98.0711 56.7726 123.64 63.2533 144.966C63.4807 144.891 63.7081 144.777 63.9355 144.625C66.7021 142.807 67.0432 136.633 62.7607 124.284C50.254 88.3738 55.2946 43.6377 47.26 32.7283Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2535 55.2289C19.2535 50.9106 19.7462 46.7438 20.6558 42.8043C16.6385 49.5469 14.0234 59.0169 14.0234 71.3658C14.0234 80.9873 16.1079 88.2223 17.4343 92.73C18.5713 96.7453 21.5274 105.988 28.3113 116.822C33.6172 125.307 39.0367 131.216 43.812 135.307C39.4536 126.519 36.308 120.004 35.8153 118.829C33.693 113.753 19.2535 85.798 19.2535 55.2289Z",
    fill: "#E9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6582 235.007H101.38V230.84L69.6582 230.878V235.007Z",
    fill: "#3E809D",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.644 224.666H69.3541C67.9139 224.666 66.7012 225.84 66.7012 227.317V230.613C66.7012 232.052 67.876 233.265 69.3541 233.265H101.606C103.046 233.265 104.259 232.09 104.259 230.613V227.317C104.259 225.878 103.084 224.666 101.644 224.666Z",
    fill: "#FCEFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1967 233.227C83.1502 233.189 80.5352 237.81 80.5352 242.09C80.5352 243.113 80.9141 245.083 82.5817 246.295C84.1735 247.469 86.5232 247.583 88.2286 246.447C90.2373 245.121 90.3889 243.151 90.3889 241.939C90.4268 237.848 86.6748 233.264 85.1967 233.227Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3821_7011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 258,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirBallon);
export default __webpack_public_path__ + "static/media/air-ballon.32fb264eba16b02ce743ca0da57c3e84.svg";
export { ForwardRef as ReactComponent };